import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../../../shared-ui/States";
import BrandLogo from "../../../shared-ui/BrandLogo";
import platformLogo from "../../../assets/branding/cranesoftwares-logo.png";
import "../../../shared-ui/crane-tokens.css";

const TILES = [
  {
    to: "/settings/profile",
    title: "Profile",
    desc: "Your account profile and personal preferences.",
  },
  {
    to: "/settings/organization",
    title: "Organization / Company",
    desc: "Tenant company details and tenant branding (logoUrl).",
  },
  {
    to: "/settings/departments",
    title: "Departments",
    desc: "Department master data for your tenant.",
  },
  {
    to: "/settings/designation",
    title: "Designations",
    desc: "Job designations used across the platform.",
  },
  {
    to: "/settings/permissions",
    title: "Roles & Permissions",
    desc: "Role definitions and permission assignments.",
  },
  {
    to: "/organization/user-management",
    title: "User Management",
    desc: "Invite, activate, and manage platform users.",
  },
  {
    to: "/platform/applications",
    title: "Applications",
    desc: "Registered applications and user app access.",
  },
  {
    to: "/audit",
    title: "Audit / Activity",
    desc: "Tenant-scoped audit event history.",
  },
  {
    to: "/search",
    title: "Global Search",
    desc: "Cross-module search over live data.",
  },
  {
    to: "/settings/maintenance",
    title: "Maintenance settings",
    desc: "Maintenance module configuration (when available).",
  },
];

export default function AdminSettingsHubPage() {
  return (
    <div className="crane-page">
      <div style={{ marginBottom: 16 }}>
        <BrandLogo src={platformLogo} size="md" alt="CraneSoftwares" decorative />
      </div>
      <PageHeader
        crumbs={["Enterprise Platform", "Administration", "Settings"]}
        title="Admin settings"
        description="Platform administration hub. Each tile opens a real settings surface wired to existing APIs — no mock configuration."
      />
      <div className="crane-admin-grid">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className="crane-admin-tile">
            <h3>{t.title}</h3>
            <p>{t.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
